/**
 * @license @tabler/icons-vue v3.34.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createVueComponent from '../createVueComponent.mjs';

var IconFeatherFilled = createVueComponent("filled", "feather-filled", "IconFeatherFilled", [["path", { "d": "M8 9.585v6.415h6.414l-2.707 2.707a1 1 0 0 1 -.112 .097l-.11 .071l-.114 .054l-.105 .035l-.149 .03l-.117 .006h-4.586l-1.707 1.707a1 1 0 1 1 -1.414 -1.414l1.707 -1.709v-4.584l.003 -.075l.017 -.126l.03 -.111l.044 -.111l.052 -.098l.067 -.096l.08 -.09z", "key": "svg-0" }], ["path", { "d": "M19.414 11l-3 3h-4.914l2.914 -3z", "key": "svg-1" }], ["path", { "d": "M13 4.586v4.998l-3 3v-4.999z", "key": "svg-2" }], ["path", { "d": "M16.482 3a4.515 4.515 0 0 1 4.518 4.514a4.7 4.7 0 0 1 -.239 1.487l-5.761 -.001v-5.76c.469 -.158 .968 -.24 1.482 -.24", "key": "svg-3" }]]);

export { IconFeatherFilled as default };
//# sourceMappingURL=IconFeatherFilled.mjs.map
